import { graphql, readInlineData } from 'react-relay';

import { type getAppliedFilterDisplayName_itemSearch$key } from './__generated__/getAppliedFilterDisplayName_itemSearch.graphql';

const itemSearchFragment = graphql`
    fragment getAppliedFilterDisplayName_itemSearch on ItemSearchQueryConnection @inline {
        appliedFilters {
            name
            values {
                displayName
            }
        }
    }
`;

export const getAppliedFilterDisplayName = (
    itemSearchRef: getAppliedFilterDisplayName_itemSearch$key | null | undefined,
    filterName: string
): string | null => {
    if (!itemSearchRef) {
        return null;
    }
    const itemSearch = readInlineData(itemSearchFragment, itemSearchRef) || {};
    return (
        (itemSearch.appliedFilters || []).find(filter => filter?.name === filterName)?.values?.[0]
            ?.displayName || null
    );
};
